import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import TipTapView from '@pages/CoursesCatalog/components/TipTapView/TipTapView'
import common from '../../common.module.css'

interface IRegistrationAgreementCheck {
  confirmed: boolean
  onClick: (value: boolean) => void
}

const RegistrationAgreementCheck: FC<IRegistrationAgreementCheck> = ({
  confirmed,
  onClick,
}) => {
  const isCustomRegistrationAgreementStore = useSelector(
    (store: any) => store.settings.isCustomRegistrationAgreement === '1',
  )
  const registrationAgreementStore = useSelector(
    (store: any) => store.settings.custom.registrationAgreementText ?? '',
  )

  const onChange = () => {
    onClick(!confirmed)
  }

  if (!isCustomRegistrationAgreementStore) return <></>

  return (
    <div className={common.agreement}>
      <div className={common.checkboxWrapper}>
        {/* @ts-ignore */}
        <CheckboxViolet
          className={common.checkbox}
          value={confirmed}
          setValue={onChange}
        />
      </div>
      <TipTapView
        className={common.tiptapAgreementsView}
        value={registrationAgreementStore}
      />
    </div>
  )
}

export default RegistrationAgreementCheck
